<template>
  <v-hover
    v-slot:default="{ hover }"
    open-delay="200"
  >
    <v-card
      :elevation="hover ? 8 : 2"
      v-if="Object.keys(pump).length !== 0"
      class="d-flex flex-column"
      height="100%"
    >
      <div class="card-capture d-flex justify-content-center" :class="'opa-' + backgroundMarket(pump.marche)">
        <div class="card-picture" :class="'bg-' + backgroundMarket(pump.marche)">
          <span aria-hidden="true" :class="'fa ' + mimeIcon"></span>
        </div>
        <p class="card-family mb-0" v-if="pump.family !== 'public'">{{ $t('theme.' + pump.family) }}</p>
      </div>
      <h2 class="v-card__title" v-if="heading === 'h2'">
        <span>
          {{ pump.name }}
          <small>{{ i18nCategory(pump.category) }}</small>
        </span>
      </h2>
      <h3 class="v-card__title" v-if="heading === 'h3'">
        <span>
          {{ pump.name }}
          <small>{{ i18nCategory(pump.category) }}</small>
        </span>
      </h3>
      <v-spacer></v-spacer>
      <v-card-actions>
        <div>
          <v-card-text class="px-2">
            <p class="mb-0">
              <languages :data="pump.languages" />
            </p>
            <p class="mb-0" v-if="isVideo">{{ $t('theme.duration') }}: <span class="fileDuration text-nowrap">{{ humanDuration }}</span></p>
            <p class="mb-0" v-else>{{ $t('theme.size') }}: <span class="fileSize text-nowrap">{{ humanSize }}</span></p>
            <p class="mb-0" v-if="pump.fsCreated">{{ $t('theme.date') }}: <span class="fileDate text-nowrap">{{ $d(new Date(Date.parse(pump.fsCreated)), 'short') }}</span></p>
          </v-card-text>
          <v-btn
            text
            color="primary"
            @click="openDocument(pump.url)"
          >
            <span v-if="isVideo">{{ $t('btn.watch') }}</span>
            <span v-else>{{ $t('btn.download') }}</span>
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="openData(pump.fid)"
          >{{ $t('btn.detail') }}</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-hover>
</template>

<script>
import Mixins from '@/core/mixins'
import Languages from '@/components/file/Languages'
const filesize = require('filesize')
const mimetype2fa = require('mimetype-to-fontawesome')({ prefix: 'fa-' })
export default {
  name: 'Documents',
  mixins: [ Mixins ],
  components: {
    Languages
  },
  props: {
    heading: {
      tpye: String,
      default: "h3"
    },
    overlay: {
      tpye: Boolean,
      default: false
    },
    pump: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    isVideo () {
      return ['videoMaintenance'].includes(this.pump.category)
    },
    mimeIcon () {
      return mimetype2fa(this.pump.fsMime)
    },
    humanSize () {
      return filesize(this.pump.fsSize)
    },
    humanDuration () {
      const humanDuration = this.pump.fsSize.replace("PT","").replace("H",":").replace("M",":").replace("S","")
      return humanDuration
    }
  },
  methods: {
    backgroundMarket (arr) {
      const test = Array.isArray(arr) && arr.length !== 0
      return test ? arr[0].toLowerCase() : (typeof arr === "string" && arr !== "" ? arr.toLowerCase() : 'none')
    },

    openDocument (url) {  
      setTimeout(() => {
        window.open(url, "_blank")
      }, 500)
    },

    openData (fid) {
      this.$root.$children[0].$refs.modalPump.openDialog(fid)
    }
  }
}
</script>
